// extracted by mini-css-extract-plugin
module.exports = {"brandStory":"brandStory_brandStory__3QcK2","wrapper":"brandStory_wrapper__110EB","map":"brandStory_map__2ntdb","caption":"brandStory_caption__-epgl","btn":"brandStory_btn__15PwZ"};